import React, { type ReactNode } from 'react';
import { style } from 'typestyle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Column from '../column/column.component';
import * as styles from './labeled.styles';
import Row from '../row/row.component';
import { CrossAxisAlignment } from '../flex/flex.component';

interface Props {
  readonly labelText?: string;
  readonly tooltipText?: string;
  readonly tooltipId?: string;
  readonly children?: ReactNode;
}

const Labeled = ({ labelText, tooltipText, tooltipId, children }: Props): React.JSX.Element => (
  <div className={style(styles.wrapper)}>
    <Column>
      <Row className={style(styles.label)} itemSpacing={8} crossAxisAlignment={CrossAxisAlignment.Center}>
        {labelText && <span>{labelText}</span>}
        {tooltipText && <InfoOutlinedIcon data-tooltip-id={tooltipId} data-tooltip-content={tooltipText} sx={styles.tooltipIconSX} />}
      </Row>
      {children}
    </Column>
  </div>
);

export default Labeled;
